import * as React from "react";
import { MenuItemLink } from "react-admin";
import StorefrontIcon from "@mui/icons-material/Storefront";

const CategoriesSubmenu = (props) => {
  return (
    <div>
      <MenuItemLink
        to="/categories"
        primaryText="View All"
        leftIcon={<StorefrontIcon />}
        sx={{
          color: "#fff",
          marginTop: 5,
          "& .RaMenuItemLink-icon": {
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

export default CategoriesSubmenu;
